// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CategoryDetailsPageContext } from "@gcg/Overrides/Pages/CategoryDetailsPage";
import { screen } from "@gcg/XDL/Helpers";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import widgetModule, { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";

import { css } from "styled-components";

columnsStyles.container = {
    gap: 0,
};

columnsStyles.leftColumnGridItem = {
    css: css`
        width: 360px;
        padding-right: 20px;
        flex-basis: 360px;
        max-width: 360px;

        ${screen("lte", "md")`
            width: 100%;
            flex-basis: 100%;
            max-width: 100%;
            padding-right: 0;
            margin-bottom: 30px;
        `}
    `,
};

columnsStyles.rightColumnGridItem = {
    css: css`
        width: calc(100% - 360px);
        flex-basis: calc(100% - 360px);
        max-width: calc(100% - 360px);
        ${screen("lte", "md")`
            width: 100%;
            flex-basis: 100%;
            max-width: 100%;
        `}
    `,
};

widgetModule.definition.allowedContexts = [ProductListPageContext, CategoryDetailsPageContext];

export default widgetModule;
